export default __webpack_public_path__ + "img/pin_icons/rolling_door_b.svg";